import React, {useState, useEffect} from 'react'

import BtnExcel from '../../Components/BtnExcel';
import Navbar from '../../Components/Navbar/Navbar'
import AntDTable from '../../Components/Table/AntDTable';
import { 
    Layout,
    Col, 
    Row,
    Input,
    Button,
    Tabs,
    Space,
} from 'antd';
import { useNavigate } from 'react-router-dom';
import { UseGetRequest } from '../../Utils/api/ApiRequests'
import { DatePicker } from 'antd';
import dayjs from 'dayjs';
import { formatDate, getEndDate, getStartDate, getTodayDateISO, getTabkey } from '../../Utils/Common';

const { RangePicker } = DatePicker;
const { TabPane } = Tabs;
const { Search } = Input;

const ElectricityMeterReadings = () => {
  const navigate = useNavigate();
  const asynch_start = getStartDate();
  const asynch_end = getEndDate();
  const asynch_key = getTabkey();

  const [electricData, setElectricData] = useState([]);
  const [exportLoading, setExportLoading] = useState(false);
  const [pageSize, setPageSize] = useState('');
  const [excelData, setExcelData] = useState([]);
  const [isLoading, setIsLoading] = useState(false);

  const [filterConfig, setFilterConfig] = useState({
    search: '',
    status: asynch_key ? asynch_key : "",
    utility_type: 'electricity',
    page: 1,
    date_from: asynch_start || '',
    date_to: asynch_end || '',
  });

  async function fetchElectricData() {
    setIsLoading(true)
    const response = await UseGetRequest("meter_readings/get", filterConfig);
    if (response?.data) {
      const reading = response?.data?.data?.map((data) => ({
        id: data.id,
        utility_type: data.utility_type,
        date_from: formatDate(data.date_from),
        date_to: formatDate(data.date_to),
        normal_rate: data.normal_rate,
        emergency_rate: data.emergency_rate,
        fully_paid: data.fully_paid,
        property_name: data.property_name,
        status: data.status,
      }))
    
      setElectricData(reading);
      setPageSize(response?.data?.size)
    } else {
      setElectricData([])
      setPageSize('')
    }
    setIsLoading(false);
  };

  async function fetchExportData() {
    setExportLoading(true)
    const response = await UseGetRequest("meter_readings/get", 
      {
        utility_type: filterConfig.utility_type,
        search: filterConfig.search,
        status: filterConfig.status,
        date_from: filterConfig.date_from,
        date_ro: filterConfig.date_to,
      }
    );
    if (response?.data) {
      const excel_data = response?.data?.data?.map((data) => ({
        utility_type: data.utility_type,
        property_name: data.property_name,
        date_from: data.date_from,
        date_to: data.date_to,
        normal_rate: data.normal_rate,
        emergency_rate: data.emergency_rate,
        fully_paid: data.fully_paid,
        added_by: data.added_by,
        added_on: data.added_on,
        updated_by: data.updated_by,
        updated_on: data.updated_on,
      }))

      setExcelData(excel_data)
      setExportLoading(false);
    } else {
      setExcelData([])
      setExportLoading(false);
    }
  };

  const onChange = (activeKey) => {
    localStorage.setItem('tabkey', JSON.stringify(activeKey));
    localStorage.removeItem('start_date');
    localStorage.removeItem('end_date');
    setFilterConfig((prev) => (
      {
        ...prev,
        date_from: '',
        date_to: '',
        status:  activeKey
      }
    ));
  };

  function ActionBtn(row) {
    return (
      <span className='center'>
        <Button className='button-color' onClick={() => navigate('/view-reading/' + row.row.utility_type +"/"+ row.row.id)}>
          View
        </Button>
      </span>
    );
  };

  const handleSearchChange = (e) => {
    setFilterConfig((prev) => (
      {
        ...prev,
        search: e || '',
        page: 1,
      }
    ));
  };
  
  const handleEmpty = (e) => {
    if(e.target.value === ''){
      setFilterConfig((prev) => (
        {
          ...prev,
          search: e.target.value || '',
          page: 1,
        }
      ));
    }
  };

  const onSearchDate = (e) => {
    if(e){
      setFilterConfig((prev) => (
        {
          ...prev,
          date_from: e[0].format("YYYY-MM-DD"),
          date_to: e[1].format("YYYY-MM-DD"),
          page: 1,
        }
      ));
      localStorage.setItem('start_date', JSON.stringify(e[0].format("YYYY-MM-DD")));
      localStorage.setItem('end_date', JSON.stringify(e[1].format("YYYY-MM-DD")));
    } else {
      setFilterConfig((prev) => (
        {
          ...prev,
          date_from: '',
          date_to: '',
          page: 1,
        }
      ));
      localStorage.removeItem('start_date');
      localStorage.removeItem('end_date');
    }
  };

  const handleTableChange = (pagination) => {
    setFilterConfig((prev) => ({
      ...prev,
      page: parseInt(pagination.current),
      page_size: pagination.pageSize
      // total_records_per_page: pagination.pageSize,
    }));
  };

  useEffect(() => {
    fetchElectricData();
    fetchExportData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [filterConfig]);

  return (
    <Layout className='page'>
      <Navbar navKey={'electricity_reading_nav'}/>
      <Layout className='content-container overflow-y'>
        <Row className='custom-padding responsive-inline responsive-tab-inline'>
          <Col span={12} className='header-container'>
            ELECTRICITY READING
          </Col>
          <Col span={12} className='mt-2 responsive-tab-width' align='end'>
            <Space className='responsive-inline'>
              <BtnExcel
                label={"Export to Excel"}
                size={"sm"}
                excelData={excelData}
                xlsxHeaders={[
                  "Utility Type",
                  "Property Name",
                  "Date From",
                  "Date To",
                  "Normal Rate",
                  "Emergency Rate",
                  "Fully Paid",
                  "Added By",
                  "Added On",
                  "Updated By",
                  "Updated On",
                ]}
                handleData={fetchExportData}
                isClicked={exportLoading}
                fileName={`Electricity_Reading_${getTodayDateISO()}.xlsx`}
              /> 
              <Button 
                className='button-color responsive-header-btn' 
                onClick={() => navigate('/add-reading/electricity')} 
                type="primary"
              >
                + Add Reading
              </Button>
            </Space>
          </Col>
        </Row>
        <Row>
          <Space className='responsive-inline excel-row'>
            <Search
              placeholder="Search..."
              size='medium'
              onSearch={(e)=>handleSearchChange(e)}
              onChange={(e)=>handleEmpty(e)}
              className='responsive-header-input'
            /> 
            <RangePicker 
              renderExtraFooter={() => 'extra footer'} 
              className='responsive-header-input'
              value={[
                filterConfig?.date_from ? dayjs(filterConfig.date_from) : null,
                filterConfig?.date_to ? dayjs(filterConfig.date_to) : null
              ]}
              onChange={(e)=>onSearchDate(e)}
            />
          </Space>
        </Row>
        <Row className='page-content'>
          <Col span={24} className='responsive-overflow-auto'>
            <Tabs 
              activeKey={filterConfig?.status}
              type="card" 
              className="custom-tabs"
              onChange={onChange}
            >
              <TabPane tab="All" key="">
                <AntDTable
                  tableHeaders={[
                    "Property",
                    "Date From",
                    "Date To",
                    "Reading Status",
                  ]}
                  headerSelector={[
                    "property_name",
                    "date_from",
                    "date_to",
                    "status",
                  ]}
                  tableData={electricData}
                  ActionBtn={(row) => ActionBtn(row)}
                  withAction={true}
                  loading={isLoading}
                  tablePages={10}
                  handleTableChange={handleTableChange}
                  filterConfig={filterConfig}
                  totalSize={pageSize}
                  isSearch={true}
                />
              </TabPane>
              <TabPane tab="Ongoing" key="ongoing">
                <AntDTable
                  tableHeaders={[
                    "Property",
                    "Date From",
                    "Date To",
                    // "Status",
                  ]}
                  headerSelector={[
                    "property_name",
                    "date_from",
                    "date_to",
                    // "status"
                  ]}
                  tableData={electricData}
                  ActionBtn={(row) => ActionBtn(row)}
                  withAction={true}
                  loading={isLoading}
                  tablePages={10}
                  handleTableChange={handleTableChange}
                  filterConfig={filterConfig}
                  totalSize={pageSize}
                  isSearch={true}
                />
              </TabPane>
              <TabPane tab="Paid" key="paid">
                <AntDTable
                  tableHeaders={[
                    "Property",
                    "Date From",
                    "Date To",
                    // "Status",
                  ]}
                  headerSelector={[
                    "property_name",
                    "date_from",
                    "date_to",
                    // "status",
                  ]}
                  tableData={electricData}
                  ActionBtn={(row) => ActionBtn(row)}
                  loading={isLoading}
                  withAction={true}
                  tablePages={10}
                  handleTableChange={handleTableChange}
                  filterConfig={filterConfig}
                  totalSize={pageSize}
                  isSearch={true}
                />
              </TabPane>
            </Tabs>
          </Col>
        </Row>
      </Layout>
    </Layout>
  )
}

export default ElectricityMeterReadings
